import { FC, ReactNode } from 'react';

interface HeaderProps {
  title: ReactNode;
  description?: ReactNode;
  menu?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

const Header: FC<HeaderProps> = ({
  title,
  description,
  menu,
  actions,
  children,
}) => {
  return (
    <header className="box-content flex flex-col items-start border-b-2 border-b-background-300 p-4">
      <div className="flex w-full flex-row flex-wrap items-center justify-between">
        <div className="flex flex-col gap-1 overflow-hidden">
          <h1 className="truncate md:text-[32px]">{title}</h1>
          {description && <span className="text-text-700">{description}</span>}
        </div>
        <div className="ml-auto flex">{actions}</div>
      </div>
      {menu && <div className="flex w-full overflow-x-auto pb-2">{menu}</div>}
      {children}
    </header>
  );
};

export default Header;
